export default __webpack_public_path__ + "static/media/HashiCorp.23debc5a.svg";